export default __webpack_public_path__ + "static/media/text-box.60f037fe.svg";